/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "kecha",
        "0": "bugun",
        "1": "ertaga",
        "future": {
          "one": "{0} kundan keyin",
          "other": "{0} kundan keyin"
        },
        "past": {
          "one": "{0} kun oldin",
          "other": "{0} kun oldin"
        }
      },
      "day-narrow": {
        "-1": "kecha",
        "0": "bugun",
        "1": "ertaga",
        "future": {
          "one": "{0} kundan keyin",
          "other": "{0} kundan keyin"
        },
        "past": {
          "one": "{0} kun oldin",
          "other": "{0} kun oldin"
        }
      },
      "day-short": {
        "-1": "kecha",
        "0": "bugun",
        "1": "ertaga",
        "future": {
          "one": "{0} kundan keyin",
          "other": "{0} kundan keyin"
        },
        "past": {
          "one": "{0} kun oldin",
          "other": "{0} kun oldin"
        }
      },
      "hour": {
        "0": "shu soatda",
        "future": {
          "one": "{0} soatdan keyin",
          "other": "{0} soatdan keyin"
        },
        "past": {
          "one": "{0} soat oldin",
          "other": "{0} soat oldin"
        }
      },
      "hour-narrow": {
        "0": "shu soatda",
        "future": {
          "one": "{0} soatdan keyin",
          "other": "{0} soatdan keyin"
        },
        "past": {
          "one": "{0} soat oldin",
          "other": "{0} soat oldin"
        }
      },
      "hour-short": {
        "0": "shu soatda",
        "future": {
          "one": "{0} soatdan keyin",
          "other": "{0} soatdan keyin"
        },
        "past": {
          "one": "{0} soat oldin",
          "other": "{0} soat oldin"
        }
      },
      "minute": {
        "0": "shu daqiqada",
        "future": {
          "one": "{0} daqiqadan keyin",
          "other": "{0} daqiqadan keyin"
        },
        "past": {
          "one": "{0} daqiqa oldin",
          "other": "{0} daqiqa oldin"
        }
      },
      "minute-narrow": {
        "0": "shu daqiqada",
        "future": {
          "one": "{0} daqiqadan keyin",
          "other": "{0} daqiqadan keyin"
        },
        "past": {
          "one": "{0} daqiqa oldin",
          "other": "{0} daqiqa oldin"
        }
      },
      "minute-short": {
        "0": "shu daqiqada",
        "future": {
          "one": "{0} daqiqadan keyin",
          "other": "{0} daqiqadan keyin"
        },
        "past": {
          "one": "{0} daqiqa oldin",
          "other": "{0} daqiqa oldin"
        }
      },
      "month": {
        "-1": "o‘tgan oy",
        "0": "shu oy",
        "1": "keyingi oy",
        "future": {
          "one": "{0} oydan keyin",
          "other": "{0} oydan keyin"
        },
        "past": {
          "one": "{0} oy oldin",
          "other": "{0} oy oldin"
        }
      },
      "month-narrow": {
        "-1": "o‘tgan oy",
        "0": "bu oy",
        "1": "keyingi oy",
        "future": {
          "one": "{0} oydan keyin",
          "other": "{0} oydan keyin"
        },
        "past": {
          "one": "{0} oy oldin",
          "other": "{0} oy oldin"
        }
      },
      "month-short": {
        "-1": "o‘tgan oy",
        "0": "bu oy",
        "1": "keyingi oy",
        "future": {
          "one": "{0} oydan keyin",
          "other": "{0} oydan keyin"
        },
        "past": {
          "one": "{0} oy oldin",
          "other": "{0} oy oldin"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "o‘tgan chorak",
        "0": "shu chorak",
        "1": "keyingi chorak",
        "future": {
          "one": "{0} chorakdan keyin",
          "other": "{0} chorakdan keyin"
        },
        "past": {
          "one": "{0} chorak oldin",
          "other": "{0} chorak oldin"
        }
      },
      "quarter-narrow": {
        "-1": "o‘tgan chorak",
        "0": "shu chorak",
        "1": "keyingi chorak",
        "future": {
          "one": "{0} chorakdan keyin",
          "other": "{0} chorakdan keyin"
        },
        "past": {
          "one": "{0} chorak oldin",
          "other": "{0} chorak oldin"
        }
      },
      "quarter-short": {
        "-1": "o‘tgan chorak",
        "0": "shu chorak",
        "1": "keyingi chorak",
        "future": {
          "one": "{0} chorakdan keyin",
          "other": "{0} chorakdan keyin"
        },
        "past": {
          "one": "{0} chorak oldin",
          "other": "{0} chorak oldin"
        }
      },
      "second": {
        "0": "hozir",
        "future": {
          "one": "{0} soniyadan keyin",
          "other": "{0} soniyadan keyin"
        },
        "past": {
          "one": "{0} soniya oldin",
          "other": "{0} soniya oldin"
        }
      },
      "second-narrow": {
        "0": "hozir",
        "future": {
          "one": "{0} soniyadan keyin",
          "other": "{0} soniyadan keyin"
        },
        "past": {
          "one": "{0} soniya oldin",
          "other": "{0} soniya oldin"
        }
      },
      "second-short": {
        "0": "hozir",
        "future": {
          "one": "{0} soniyadan keyin",
          "other": "{0} soniyadan keyin"
        },
        "past": {
          "one": "{0} soniya oldin",
          "other": "{0} soniya oldin"
        }
      },
      "week": {
        "-1": "o‘tgan hafta",
        "0": "shu hafta",
        "1": "keyingi hafta",
        "future": {
          "one": "{0} haftadan keyin",
          "other": "{0} haftadan keyin"
        },
        "past": {
          "one": "{0} hafta oldin",
          "other": "{0} hafta oldin"
        }
      },
      "week-narrow": {
        "-1": "o‘tgan hafta",
        "0": "bu hafta",
        "1": "keyingi hafta",
        "future": {
          "one": "{0} haftadan keyin",
          "other": "{0} haftadan keyin"
        },
        "past": {
          "one": "{0} hafta oldin",
          "other": "{0} hafta oldin"
        }
      },
      "week-short": {
        "-1": "o‘tgan hafta",
        "0": "bu hafta",
        "1": "keyingi hafta",
        "future": {
          "one": "{0} haftadan keyin",
          "other": "{0} haftadan keyin"
        },
        "past": {
          "one": "{0} hafta oldin",
          "other": "{0} hafta oldin"
        }
      },
      "year": {
        "-1": "o‘tgan yil",
        "0": "shu yil",
        "1": "keyingi yil",
        "future": {
          "one": "{0} yildan keyin",
          "other": "{0} yildan keyin"
        },
        "past": {
          "one": "{0} yil oldin",
          "other": "{0} yil oldin"
        }
      },
      "year-narrow": {
        "-1": "o‘tgan yil",
        "0": "bu yil",
        "1": "keyingi yil",
        "future": {
          "one": "{0} yildan keyin",
          "other": "{0} yildan keyin"
        },
        "past": {
          "one": "{0} yil oldin",
          "other": "{0} yil oldin"
        }
      },
      "year-short": {
        "-1": "o‘ʻtgan yil",
        "0": "bu yil",
        "1": "keyingi yil",
        "future": {
          "one": "{0} yildan keyin",
          "other": "{0} yildan keyin"
        },
        "past": {
          "one": "{0} yil oldin",
          "other": "{0} yil oldin"
        }
      }
    },
    "locale": "uz"
  });
}